<template>
  <v-container fluid>
    <el-overlay-loading :loading="pageloading" />

    <v-card>
      <v-card-text>
        <h3 class="mb-4">Aktyvios paslaugos</h3>

        <v-data-table
          :loading="loading"
          :headers="headers"
          :items="filterItemList"
          :search="search"
          :footer-props="{
            showFirstLastPage: true,
            showCurrentPage: true,
            itemsPerPageText: 'Rodyti po:',
            itemsPerPageAllText: 'visi',
            itemsPerPageOptions: itemsPerPageOptions,
          }"
          :hide-default-footer="hideFooter"
          :items-per-page="pageSize"
        >
          <template #top>
            <v-toolbar flat
              ><v-text-field
                v-model="search"
                prepend-icon="mdi-magnify"
                label=""
                single-line
                hide-details
              ></v-text-field>
            </v-toolbar>
          </template>
          <template #[`item.pranesimo_busena`]="{ item }">
            <el-hipoteka-busena :busena="item.pranesimo_busena" />
          </template>
          <template #[`item.actions`]="{ item }">
            <el-savitarna-action
              :item="item"
              :loading="item.loading"
              @savitarnaAction="savitarnaAction"
            />
          </template>
          <template slot="loading">
            Kraunasi...
          </template>
          <template slot="no-results">
            Duomenų nėra
          </template>
          <template slot="no-data">
            Duomenų nėra
          </template>
          <template #[`footer.page-text`]="props">
            Rodoma {{ props.pageStart }}-{{ props.pageStop }} iš
            {{ props.itemsLength }}
          </template>
        </v-data-table>

        <modal-delete
          title="Šalinti dokumentą?"
          :text="
            `Ar norite pašalinti rengiamą dokumentą <strong>${modalDeleteVardas}</strong>?`
          "
          v-model="showDelete"
          :item="modalDeleteItem"
          @confirmDelete="confirmDelete"
        />
        <modal-confirm
          :title="modalConfirmTitle"
          :text="modalConfirmText"
          v-model="showConfirm"
          :item="modalConfirmItem"
          @confirmConfirm="confirmConfirm"
          @cancelConfirm="cancelData"
        />
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import HipotekaMap from '../hipoteka/hipotekaMap'
import ModalDelete from '../modals/ModalDelete'
import ModalConfirm from '../modals/ModalConfirm'
import savitarnaVeiksmas from '../../mixins/savitarnaVeiksmas'

export default {
  name: 'AktyviosPaslaugos',
  components: {
    ModalDelete,
    ModalConfirm,
  },
  mixins: [savitarnaVeiksmas],
  data() {
    return {
      pageloading: true,
      loading: true,
      pranesimai: [],
      search: null,
      showDelete: false,
      modalDeleteVardas: '',
      modalDeleteItem: null,
      modalConfirmTitle: null,
      modalConfirmText: null,
      modalConfirmItem: null,
      showConfirm: false,
      headers: [
        {
          text: 'Dokumento numeris',
          align: 'start',
          value: 'obj_dokumento_numeris',
        },
        {
          text: 'Pavadinimas',
          align: 'start',
          value: 'pavadinimas',
        },
        {
          text: 'Identifikavimo kodas (IDK)',
          align: 'start',
          value: 'dokumento_numeris',
        },
        {
          text: 'Šalis (pirma)',
          align: 'start',
          value: 'skolininkai',
        },
        {
          text: 'Šalis (antra)',
          align: 'start',
          value: 'kreditoriai',
        },
        {
          text: 'Būsena',
          align: 'start',
          value: 'pranesimo_busena',
        },
        {
          text: 'Būsenos data',
          align: 'start',
          value: 'pranesimo_busenos_data',
        },
        {
          text: 'Paskutinio keitimo data',
          align: 'start',
          value: 'atnaujinimo_data',
        },
        {
          text: 'Numatoma pašalinimo data',
          align: 'start',
          value: 'numatoma_pasalinimo_data',
        },
        {
          text: 'Veiksmai',
          align: 'start',
          sortable: false,
          value: 'actions',
        },
      ],
      itemsPerPageOptions: [5, 10, 50],
      pageSize: 5,
      lockInterval: null,
      lockTimeout: 10000,
    }
  },
  computed: {
    ...mapGetters(['objektasID', 'hipotekaTipas']),

    asmuoRole() {
      return HipotekaMap['asmenysRoles'].informuojamas
    },
    filterItemList() {
      return this.pranesimai.map(pranesimas => {
        pranesimas.pavadinimas = HipotekaMap['hipotekaTipas'][
          pranesimas.pranesimo_rusis
        ]
          ? HipotekaMap['hipotekaTipas'][pranesimas.pranesimo_rusis].title
          : pranesimas.pranesimo_rusis

        pranesimas.skolininkai = pranesimas.skol_ir_gav.join(', ')
        pranesimas.kreditoriai = pranesimas.kred_ir_dav.join(', ')

        pranesimas.veiksmasList = pranesimas.veiksmai.map(veiksmas => {
          let veiksmasNew = {
            kodas: veiksmas,
            title: veiksmas,
            role: [],
          }

          let key = Object.keys(HipotekaMap['savitarnaVeiksmas']).find(
            e => veiksmas === e
          )
          if (key) {
            veiksmasNew = {
              kodas: veiksmas,
              ...HipotekaMap['savitarnaVeiksmas'][key],
            }
          }

          return veiksmasNew
        })

        return pranesimas
      })
    },
    hideFooter() {
      return this.filterItemList.length <= 5
    },
    isLocked() {
      return this.pranesimai.filter(item => item.obj_uzrakinta).length > 0
    },
  },
  beforeDestroy() {
    this.stopLoading()
  },
  created() {
    this.loading = true
    this.getData()
  },
  methods: {
    getData() {
      this.$axios
        .get(`pagrindinis/aktyvios-paslaugos`)
        .then(res => {
          this.pranesimai = res.data.pranesimai
          this.checkLoading()
        })
        .catch(err => {
          window._VMA.$emit('DATA_ERROR', err.response.data.message)
        })
        .finally(() => {
          this.loading = false
          this.pageloading = false
        })
    },
    checkLoading() {
      if (this.isLocked) {
        if (!this.lockInterval) {
          this.lockInterval = setInterval(() => {
            this.getData()
          }, this.lockTimeout)
        }
      } else {
        this.stopLoading()
      }
    },
    stopLoading() {
      clearInterval(this.lockInterval)
    },
  },
}
</script>
